import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.9149 4.91489L14.0851 4.08511C13.4863 3.48632 12.5503 3.44974 11.9965 4.00349L4.03135 11.9687C3.96951 12.0305 3.92785 12.1106 3.91084 12.1986L3.37562 15.0702C3.34583 15.2296 3.40122 15.4012 3.5228 15.5228L3.52584 15.5258C3.64843 15.6484 3.82187 15.7019 3.98221 15.6693L6.80259 15.0941C6.88857 15.077 6.96482 15.0352 7.02572 14.9743L14.9965 7.00349C15.5503 6.44974 15.5137 5.51368 14.9149 4.91489ZM13.4292 4.74098L14.259 5.57077C14.4667 5.77847 14.4794 6.10219 14.2873 6.29427L13.4628 7.1188L11.8812 5.53724L12.7057 4.71271C12.8978 4.52063 13.2215 4.53328 13.4292 4.74098ZM4.46493 14.5685L4.83614 12.5823L11.2253 6.19312L12.8069 7.77468L6.40833 14.1732L4.46399 14.5694L4.46493 14.5685Z"
      fill={props.color || "#4F4F4F"}
    />
  </svg>
);

export default SVGComponent;
